import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';

export default function Routines() {
    const [routines, setRoutines] = useState("")
    const [filteredRoutines, setFilteredRoutines] = useState([]);
    const [filter, setFilter] = useState("");

    useEffect(() => {
        async function getRoutines() {
            try {
                const response = await fetch('https://fitnesstrac-kr.herokuapp.com/api/routines/', {
                    headers: {
                        'Content-type': 'application/json'
                    }
                });
                const result = await response.json();
                setRoutines(result);
                setFilteredRoutines(result);
            } catch (err) {
                console.log(err);
            }
        }
        getRoutines();
    }, []);

    useEffect(() => {
        const routinesArray = Object.values(routines)
        setFilteredRoutines(
            routinesArray.filter((routine) => {
                return (
                    routine.name.toLowerCase().includes(filter.toLowerCase()) ||
                    routine.goal.toLowerCase().includes(filter.toLowerCase())
                );
            })
        );
    }, [filter, routines]);


    return (
        <div className="routines-container">
            <div className="routines-header">
                <h1>Routines</h1>
                <div className="routines-filter">
                    <input
                        type="filter-text"
                        placeholder="Filter routines"
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>
            </div> 
            {filteredRoutines.map((routine) => {
                return (
                    <div key={routine.id} className="card">
                        <h2>{routine.name}</h2>
                        <div>{routine.goal}</div>
                        <div>{routine.creatorName}</div>
                        <h5>Activies in Routine</h5>
                        {routine.activities.map((activity) => {
                            return (
                                <div key={activity.id}>
                                <div>Name: {activity.name}</div>
                                {activity.duration ? <div>Duration: {activity.duration}</div> : null}
                                {activity.count ? <div>Count: {activity.count}</div> : null}
                                <br></br> 
                                </div>
                            )
                        }
                        )}
                        <Link>
                            <button>Edit Routine (currently disabled)</button>
                        </Link>
                    </div>
                );
            })}
        </div>
    );
}
